import { render, staticRenderFns } from "./StudiosUebersicht.vue?vue&type=template&id=7f523a34&scoped=true&"
import script from "./StudiosUebersicht.vue?vue&type=script&lang=js&"
export * from "./StudiosUebersicht.vue?vue&type=script&lang=js&"
import style0 from "./StudiosUebersicht.vue?vue&type=style&index=0&id=7f523a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f523a34",
  null
  
)

export default component.exports